export default __webpack_public_path__ + "static/media/long-duration.51426794.png";